import {
  useSessionStorageManualPaginatedResource,
  type SessionStorageFiltersConfig,
} from "../../../shared/hooks/useSessionStorageManualPaginatedResource";
import { useGetSwimmersReportPreview } from "../services/swimmerService";

type SwimmersPreviewFilters = {
  swimmer_name: string;
  building_id: string;
  lifeguard_name: string;
  start_date: string;
  end_date: string;
};

const SWIMMERS_PREVIEW_FILTER_CONFIG: SessionStorageFiltersConfig<SwimmersPreviewFilters> =
  {
    defaultFilters: {
      swimmer_name: "",
      building_id: "",
      lifeguard_name: "",
      start_date: "",
      end_date: "",
    },
    filterKeys: [
      "swimmer_name",
      "building_id",
      "lifeguard_name",
      "start_date",
      "end_date",
    ],
    tabStorageId: "banistas",
  };

export const useSwimmersPreviewResource = () => {
  const {
    page,
    pageSize,
    draftFilters,
    appliedFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    applyFilters,
    resetFilters,
  } = useSessionStorageManualPaginatedResource(SWIMMERS_PREVIEW_FILTER_CONFIG);

  const {
    data: swimmersData,
    isLoading,
    isError,
    isFetching,
    refetch,
  } = useGetSwimmersReportPreview({
    page,
    page_size: pageSize,
    building_id: appliedFilters.building_id || undefined,
    lifeguard_name: appliedFilters.lifeguard_name || undefined,
    start_date: appliedFilters.start_date || undefined,
    end_date: appliedFilters.end_date || undefined,
  });

  return {
    data: swimmersData,
    isLoading,
    isError,
    isFetching,
    page,
    pageSize,
    filters: draftFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    applyFilters,
    resetFilters,
    refetch,
  };
};
